import { HStack, motion } from '@hover/blueprint';
import React from 'react';

import example1 from 'src/assets/img/homeownerApp/exterior/japanese-modern.jpg';
import example3 from 'src/assets/img/homeownerApp/exterior/minimalist.jpg';
import example2 from 'src/assets/img/homeownerApp/interior/scandinavian.jpg';
import { Image } from 'src/shared/components';

const variants = {
  onScreen: {
    x: -75,
    transition: {
      staggerChildren: 0.08,
      type: 'spring',
      bounce: 0.25,
    },
  },
  offScreen: { x: 5 },
};

const ImageGrid = () => (
  <motion.div animate="onScreen" initial="offScreen" variants={variants}>
    <HStack
      alignItems="flex-end"
      display="flex"
      gap={{ tablet: 400 }}
      marginLeft={{ base: 400, tablet: 1100 }}
    >
      <motion.div variants={variants}>
        <Image
          alt=""
          borderRadius={4}
          maxWidth={{ base: '160px', tablet: '383px' }}
          minH={{ base: '209px', tablet: '500px' }}
          objectFit="cover"
          src={example1}
        />
      </motion.div>
      <motion.div variants={variants}>
        <Image
          alt=""
          borderRadius={4}
          maxWidth={{ base: '136px', tablet: '325px' }}
          minH={{ base: '168px', tablet: '425px' }}
          objectFit="cover"
          src={example2}
        />
      </motion.div>
      <motion.div variants={variants}>
        <Image
          alt=""
          borderRadius={4}
          maxWidth={{ base: '160px', tablet: '383px' }}
          minH={{ base: '209px', tablet: '500px' }}
          objectFit="cover"
          src={example3}
        />
      </motion.div>
    </HStack>
  </motion.div>
);

export { ImageGrid };
